import Icon from '../components/Icon.vue'

Icon.register({
  umbrella: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.7 280.8c2.2 10.1-8.4 21.4-18.7 11.4-51.5-54.4-107.6-52.5-158.6 37-5.3 9.5-14.9 8.6-19.7 0-2.5-4.4-32.2-73.2-90.7-73.2-45.8 0-70.5 37.8-90.7 73.2-4.8 8.6-14.4 9.5-19.7 0-50.9-89.4-106.6-92-158.6-37-10.2 9.9-20.9-1.3-18.7-11.4 29.2-136.3 138-218.2 255.7-230.9v-17.9c0-17.7 14.3-32 32-32s32 14.3 32 32v17.9c117.3 12.7 227.1 94.6 255.7 230.9zM256 301.7c9.6-8.9 19.7-13.6 32-13.7 12.2 0 22.9 5.7 32 13.6v130.3c0 44.1-35.9 80-80 80-33.8 0-64.2-21.4-75.4-53.3-5.9-16.6 2.8-34.9 19.5-40.8 16.7-5.9 34.9 2.8 40.8 19.5 1.9 5.4 7.3 10.7 15.1 10.7 8.8 0 16-7.2 16-16v-130.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/umbrella.js
// module id = 2046
// module chunks = 0